import { render, staticRenderFns } from "./ChooseLanguage.vue?vue&type=template&id=67a18ba0&"
import script from "./ChooseLanguage.vue?vue&type=script&lang=js&"
export * from "./ChooseLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a18ba0')) {
      api.createRecord('67a18ba0', component.options)
    } else {
      api.reload('67a18ba0', component.options)
    }
    module.hot.accept("./ChooseLanguage.vue?vue&type=template&id=67a18ba0&", function () {
      api.rerender('67a18ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/ChooseLanguage.vue"
export default component.exports